import B_Define from '../../../../base/dev/util/B_Define';
import G_Define from '../../util/G_Define';
import B_Real from '../../../../base/dev/child/base/B_Real';
import B_ChildWorld from '../../../../base/dev/child/base/B_ChildWorld';
import B_GridChild from '../../../../base/dev/child/grid/B_GridChild';
import B_Inventory from '../../../../base/dev/child/attr/B_Inventory';
import G_GridChild from '../grid/G_GridChild';
import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';

let mix = (superclass) => new MixinBuilder(superclass);

const init = () => {
    return class G_SpriteHero extends mix(B_Real).with(
        B_ChildWorld, B_GridChild, G_GridChild, B_Inventory
    ) {
        constructor(obj) {
            super(obj);

            this._w = this._gridDisX * this._size / 100;
            this._h = this._gridDisY * this._size / 100;

            const res = this.CODMOS._res[obj.res].result;
            this._sprite = new createjs.SpriteSheet({
                ...res,
                images: res.images.map((e, i) => this.CODMOS._res[`${obj.res}-image-${i}`].result)
            });
            this._object = new createjs.Sprite(this._sprite, 'run');
            this.animation = this._getSelectMotion('stand');
            this._container.addChild(this._object);

            this.rotate = obj.rotate || this.CODMOS._res[obj.res].rotate || 180;

            this._speed = this.CODMOS.ANIMATE._tween.getCanvas().speed;
        }

        _endAction(cb) {
            this._moveStatus = false;

            const STATE = this.CODMOS.WORLD.STATE.renew();
            if (STATE.clear === B_Define.CLEAR_STATUS.SUCCESS) {
                this._container.regX = this.regX;
                this.animation = 'DancingBottom';
            }
            if (typeof this.CODMOS.onCanvasEvent === 'function') this.CODMOS.onCanvasEvent(STATE);
            if (typeof cb === 'function') cb(STATE);
        }

        // 이동
        async _forward(action, distance, cb) {
            const { STATE } = this.CODMOS.WORLD;

            // 임시 이동
            this._virtualMove(distance);

            // 충돌, 길 벗어남 등 상태 확인
            const { CRUSH_STATUS, CRUSH_OBJECT, CRUSH_PATH } = await this.getCrushStatus();

            // 임시 이동 회귀
            this._virtualMoveReset();

            this.animation = this._getSelectMotion(action);

            if (CRUSH_STATUS) {
                // 충돌 처리
                STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.CRUSH, null);
                this._crush(distance, cb);
            } else {
                // 앞으로 이동
                const fPixel = this._getFrontPixel(this.rotate, distance);
                const fGrid = this._getFrontGrid(this.rotate, distance);

                this.CODMOS.ANIMATE._tween.move(
                    this,
                    '',
                    fPixel[0],
                    fPixel[1],
                    async () => {
                        this.animation = this._getSelectMotion('stand');
                        this._setGridXWithPixel(fGrid[0]);
                        this._setGridYWithPixel(fGrid[1]);

                        const SWITCHES = Object.values(this.CODMOS.WORLD.LIST.switch);

                        SWITCHES.forEach((e) => {
                            e._switch(this._gridX === e._gridX && this._gridY === e._gridY);
                        });

                        await this._postMove(CRUSH_OBJECT, CRUSH_PATH);

                        this._endAction(cb);
                    }
                );
            }
        }

        _postMove(target, path) {
            return new Promise((resolve) => {
                if (typeof path !== 'undefined') {
                    const TARGET_VARIABLE = path._damageTarget || '인트의 체력';
                    if (typeof path._damage === 'number'
                        && typeof this.CODMOS.WORLD[TARGET_VARIABLE] !== 'undefined') {
                        this.CODMOS.WORLD[TARGET_VARIABLE].minusValue(path._damage);
                    }
                }
                Object.values(this.CODMOS.WORLD.LIST.path).forEach((e) => {
                    if (typeof e._above === 'undefined') return;
                    if (
                        this.checkUnderResource(e._above.res, e._gridX, e._gridY) === true
                        && typeof e._above.variance !== 'undefined'
                        && this.CODMOS.WORLD[e._above.variable]
                    ) {
                        this.CODMOS.WORLD[e._above.variable].plusValue(e._above.variance);
                    }
                });

                if (typeof target !== 'undefined') {
                    switch (target._type) {
                        case G_Define.GOAL_TYPE:
                        case G_Define.INSPECTOR_TYPE: {
                            const heroID = 'hero';
                            if (G_Define.IS_SENSOR_ANSWER_SOMETHING(heroID, this.CODMOS)) resolve();
                            else target._checkSolution(this, resolve);
                            break;
                        }
                        case G_Define.PORTAL_TYPE: {
                            target._movePortal(this, resolve);
                            break;
                        }
                        default: {
                            resolve();
                        }
                    }
                } else resolve();
            });
        }

        moveForward(cb) {
            if (this._checkMoveStatus) return;
            this._forward('move', 1, cb);
        }

        moveTop(cb) {
            if (this._moveStatus) return;
            this.rotate = 360;
            this.moveForward(cb);
        }

        moveDown(cb) {
            if (this._moveStatus) return;
            this.rotate = 180;
            this.moveForward(cb);
        }

        moveRight(cb) {
            if (this._moveStatus) return;
            this.rotate = 90;
            this.moveForward(cb);
        }

        moveLeft(cb) {
            if (this._moveStatus) return;
            this.rotate = 270;
            this.moveForward(cb);
        }

        _crush(distance, cb) {
            const fPixel = this._getFrontPixel(this.rotate, distance);
            const bPixel = [this._getGridPixelX(), this._getGridPixelY()];

            this.CODMOS.ANIMATE._tween.crush(
                this,
                '',
                (fPixel[0] + bPixel[0]) / 2,
                (fPixel[1] + bPixel[1]) / 2,
                bPixel[0],
                bPixel[1],
                () => {
                    this.animation = this._getSelectMotion('stand');

                    this._endAction(cb);
                }
            );
        }

        // 점프
        jumpForward(cb) {
            if (this._checkMoveStatus) return;
            const TEMP_SPPED = this._speed;
            if (TEMP_SPPED === 1) this._speed = 1.5;
            switch (this.rotate) {
                case 90:
                case 270: {
                    this._container.regX = this.regX + 10;
                    break;
                }
                case 360: {
                    this._container.regY = this.regY + 40;
                    break;
                }
                default:
            }
            this._forward('jump', 2, () => {
                this._container.regX = this.regX;
                this._container.regY = this.regY;
                this._speed = TEMP_SPPED;
                if (typeof cb === 'function') cb();
            });
        }

        // 밀기
        pushTop(cb) {
            if (this._moveStatus) return;
            this.rotate = 360;
            this.pushAndMove(cb);
        }

        pushDown(cb) {
            if (this._moveStatus) return;
            this.rotate = 180;
            this.pushAndMove(cb);
        }

        pushRight(cb) {
            if (this._moveStatus) return;
            this.rotate = 90;
            this.pushAndMove(cb);
        }

        pushLeft(cb) {
            if (this._moveStatus) return;
            this.rotate = 270;
            this.pushAndMove(cb);
        }

        async pushAndMove(cb) {
            if (this._checkMoveStatus) return;
            // 임시 이동
            this._virtualMove(1);

            // 충돌, 길 벗어남 등 상태 확인
            const { CRUSH_OBJECT, CRUSH_PATH } = await this.getCrushStatus();

            // 임시 이동 회귀
            this._virtualMoveReset();

            this._moveStatus = false;

            if (
                typeof CRUSH_OBJECT === 'object'
                && !CRUSH_OBJECT._disable
                && G_Define.PUSH_TYPES.indexOf(CRUSH_OBJECT._type) !== -1
            ) {
                const fPixel = this._getFrontPixel(this.rotate, 1);
                const fGrid = this._getFrontGrid(this.rotate, 1);
                const bPixel = [this._pixelX, this._pixelY];

                this.animation = this._getSelectMotion('move');
                this.CODMOS.ANIMATE._tween.move(
                    this,
                    '',
                    (fPixel[0] + bPixel[0]) / 2,
                    (fPixel[1] + bPixel[1]) / 2,
                    () => {
                        this.pushItem((boolCrushOut, SUCCESS_STATUS) => {
                            // 아이템 <-> 벽 출동
                            if (boolCrushOut && !G_Define.IS_SENSOR_ANSWER(CRUSH_OBJECT._id, this.CODMOS)) {
                                this._crush(1, cb);
                            } else {
                                this.CODMOS.ANIMATE._tween.move(
                                    this,
                                    '',
                                    fPixel[0],
                                    fPixel[1],
                                    async () => {
                                        this.animation = this._getSelectMotion('stand');
                                        this._setGridXWithPixel(fGrid[0]);
                                        this._setGridYWithPixel(fGrid[1]);

                                        const SWITCHES = Object.values(
                                            this.CODMOS.WORLD.LIST.switch
                                        );

                                        SWITCHES.forEach((e) => {
                                            e._switch(
                                                this._gridX === e._gridX && this._gridY === e._gridY
                                            );
                                        });

                                        await this._postMove(CRUSH_OBJECT, CRUSH_PATH);

                                        this.CODMOS.run();

                                        if (SUCCESS_STATUS) {
                                            this.CODMOS.WORLD.STATE.going(
                                                B_Define.CLEAR_STATUS.SUCCESS,
                                                B_Define.REASON.SUCCESS,
                                                this
                                            );
                                        }

                                        this._endAction(cb);
                                    }
                                );
                            }
                        });
                    }
                );
            } else {
                this.moveForward(() => {
                    this.CODMOS.run();

                    if (typeof cb === 'function') cb();
                });
            }
        }

        pushItem(cb) {
            if (this._checkMoveStatus) return;
            // [#01]
            const x = this._pixelX;
            const y = this._pixelY;
            // [#02] 앞에 PUSH-ITEM이 있는지 확인
            let pushItem;
            for (const type of G_Define.PUSH_TYPES) {
                if (pushItem) break;
                pushItem = this.checkFrontType(type, this.rotate);
            }
            this._pixelX = x;
            this._pixelY = y;
            // [CASE1] 밀기 <= [#03]
            pushItem._pushed(this.rotate, (CRUSH_STATUS, SUCCESS_STATUS) => {
                this._moveStatus = false;
                if (typeof cb === 'function') cb(!CRUSH_STATUS, SUCCESS_STATUS);
            });
        }

        // 회전
        rotateLeft(cb) {
            if (this._checkMoveStatus) return;
            this.rotate -= 90;

            this._endAction(cb);
        }

        rotateRight(cb) {
            if (this._checkMoveStatus) return;
            this.rotate += 90;

            this._endAction(cb);
        }

        get rotate() { return this._rotate; }

        set rotate(rotate) {
            rotate = rotate % 360 || 360;
            switch (rotate) {
                case 270: {
                    this._container.regX = this.regX + 10;
                    this._container.scaleX = Math.abs(this._container.scaleX) * -1;
                    break;
                }
                case 90: {
                    this._container.regX = this.regX + 10;
                    this._container.scaleX = Math.abs(this._container.scaleX);
                    break;
                }
                case 180:
                case 360: {
                    this._container.regX = this.regX;
                    this._container.scaleX = Math.abs(this._container.scaleX);
                    break;
                }
                default:
            }
            this.animation = this._getSelectMotion('stand', rotate);
            this._rotate = rotate;
        }

        // 아이템
        getItem(res, arr, cb) {
            if (this._checkMoveStatus) return;

            const { STATE } = this.CODMOS.WORLD;

            // 파라미터 필터링
            if (typeof res === 'function') {
                cb = res;
                res = undefined;
            }
            if (typeof cb === 'undefined' && typeof arr === 'function') {
                cb = arr;
                arr = undefined;
            }

            // 해당 좌표에 위치한 아이템 조회
            const ITEM = this.checkUnderType(G_Define.GET_ITEM_TYPE);
            if (ITEM) {
                if (ITEM._dontGet === true) {
                    STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.DO_NOT_GET);
                    this._endAction(cb);
                } else if (res && ITEM._res !== res) {
                    STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.NOT_MATCH_RES);
                    this._endAction(cb);
                } else {
                    this._insertInventory(ITEM);

                    const target = ITEM._variableTarget;
                    const variableReal = this.CODMOS.WORLD.LIST.variableReal[target];
                    if (variableReal && variableReal._isOperation) {
                        const symbols = G_Define.OPERATION_SYMBOL;
                        const valueStr = `${ITEM._value}`;
                        const firstSymbol = valueStr.slice(0, 1);
                        let num = Number(valueStr.slice(1, valueStr.length));
                        num = isNaN(num) ? 0 : num;
                        symbols.some((e) => {
                            const bool = e.symbol === firstSymbol;
                            if (bool) variableReal._value = e.do(variableReal._value, num);
                            return bool;
                        });

                        if (variableReal._value <= 0) {
                            STATE.going(B_Define.CLEAR_STATUS.FAIL, B_Define.REASON.WRONG_VALUE);
                            this._endAction(cb);
                        }
                    }

                    this.CODMOS.ANIMATE.itemUp(ITEM, () => {
                        ITEM._remove();
                        if (arr) this._variableChange(arr);

                        const ITEM_SOLUTION = Object.values(
                            this.CODMOS.WORLD.LIST[B_Define.ITEM_SOLUTION_TYPE]
                        );
                        const isSuccess = ITEM_SOLUTION.length
                            && !ITEM_SOLUTION.some(e => !e._compareInventoryNew(this));

                        if (isSuccess) {
                            STATE.going(
                                B_Define.CLEAR_STATUS.SUCCESS, B_Define.REASON.SUCCESS, this
                            );
                        } else STATE.going(B_Define.CLEAR_STATUS.GOING, '', ITEM);

                        this._endAction(cb);
                    });
                }
            } else {
                STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.NULL);
                this._endAction(cb);
            }
        }

        actionItem(cb) {
            if (this._checkMoveStatus) return;

            const { STATE } = this.CODMOS.WORLD;

            const ITEM = this.checkUnderType(G_Define.ACTION_ITEM_TYPE);
            if (ITEM) {
                this._insertInventory(ITEM);

                this.CODMOS.ANIMATE.actionUp(ITEM, () => {
                    ITEM._remove();
                    STATE.going(B_Define.CLEAR_STATUS.GOING, '', ITEM);
                    this._endAction(cb);
                });
            } else {
                STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.NULL);
                this._endAction(cb);
            }
        }

        putItem(res, arr, cb) {
            if (this._checkMoveStatus) return;

            // 파라미터 필터링
            if (typeof cb === 'undefined' && typeof arr === 'function') {
                cb = arr;
                arr = undefined;
            }

            const TARGET_PATH = this.checkUnderType('path');

            if (
                typeof TARGET_PATH !== 'undefined'
                && TARGET_PATH !== null
                && typeof TARGET_PATH._above !== 'undefined'
                && TARGET_PATH._above.res === res
                && TARGET_PATH._above.enable !== 'N'
                && typeof TARGET_PATH._above.value !== 'undefined'
            ) {
                this.CODMOS.WORLD[TARGET_PATH._above.variable].plusValue(TARGET_PATH._above.value);
                TARGET_PATH._above.enable = 'N';
            }

            const { STATE } = this.CODMOS.WORLD;

            const IS_ITEM = this.checkUnderType(G_Define.GET_ITEM_TYPE);

            if (IS_ITEM === false) {
                this.CODMOS.WORLD[this._strParent].addObject({
                    x: this._gridX,
                    y: this._gridY,
                    res,
                    id: `${this.CODMOS._res[res].type}-${Math.random().toString(36).substring(2, 15)}`
                });
                if (arr) this._variableChange(arr);
                Object.values(this.CODMOS.WORLD.LIST[B_Define.RESOURCE_SOLUTION_TYPE]).some(e => e._compareResource())
                    ? STATE.going(B_Define.CLEAR_STATUS.SUCCESS, B_Define.REASON.SUCCESS, this)
                    : STATE.going(B_Define.CLEAR_STATUS.GOING, '');
            } else STATE.going(B_Define.CLEAR_STATUS.FAIL, B_Define.REASON.ALREADY_ITEM_EXISTS);

            this._endAction(cb);
        }

        // 변수
        _variableChange(arr) {
            arr = JSON.parse(arr);
            if (!Array.isArray(arr)) return null;
            return arr.some((e) => {
                if (
                    Array.isArray(e)
                    && this.CODMOS.WORLD[e[0]]
                    && typeof this.CODMOS.WORLD[e[0]].plusValue === 'function'
                ) return this.CODMOS.WORLD[e[0]].plusValue(e[1]);
            });
        }

        _postGetAttr(type, cb) {
            let CRUSH_OBJECT = false;

            for (let i = 0; i < type.length; i++) {
                const RTN = this.checkUnderType(type[i]);
                if (RTN) {
                    CRUSH_OBJECT = RTN;
                    break;
                }
            }

            if (CRUSH_OBJECT) {
                const ACTION_SOLUTION = this.CODMOS.WORLD.LIST[B_Define.ACTION_SOLUTION_TYPE];
                if (typeof ACTION_SOLUTION === 'object') {
                    cb(Object.values(ACTION_SOLUTION).some(e => !e._compareGetValue(CRUSH_OBJECT)));
                }
            }
        }

        readValue(cb) {
            if (this._moveStatus) return;

            this.readAttr({ cb });
        }

        readAttr(json) {
            if (this._checkMoveStatus) return;

            const ATTR = json.attr || 'value';
            const TYPE = json.type || 'getItem';
            const TARGET = json.target || this.getUnderAttr('variableTarget', TYPE);
            const ERR = json.err || 'NULL';

            const { STATE } = this.CODMOS.WORLD;

            this._postGetAttr([
                G_Define.GET_ITEM_TYPE,
                G_Define.PATH_TYPE
            ], (err) => {
                const VALUE = this.getUnderAttr(ATTR, TYPE);

                if (err === true) {
                    STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON[ERR]);
                } else if (typeof VALUE === 'number') {
                    this.CODMOS.WORLD[TARGET].setValue(VALUE);
                    STATE.going(B_Define.CLEAR_STATUS.GOING, '');
                } else {
                    STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.NON_VALUE);
                }

                this._endAction(json.cb);
            });
        }

        changeValue(value, arr, cb) {
            if (this._checkMoveStatus) return;

            if (typeof cb === 'undefined' && typeof arr === 'function') {
                cb = arr;
                arr = undefined;
            }
            const { STATE } = this.CODMOS.WORLD;
            if (!arr || !this._variableChange(arr)) {
                const CHANGE_VALUE = this.changeUnderAttr('value', 'getItem', value);

                if (CHANGE_VALUE === false) {
                    STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.OBJ_SET);
                } else if (typeof CHANGE_VALUE !== 'undefined') {
                    STATE.going(B_Define.CLEAR_STATUS.GOING, '');
                } else {
                    STATE.going(B_Define.CLEAR_STATUS.FAIL, G_Define.REASON.NON_VALUE);
                }
            }

            this._endAction(cb);
        }

        // itemOperation() {
        //     console.log('itemOperation!!');
        // }
        //

        _virtualMove(distance) {
            for (let i = 0; i < distance; i++) {
                this._locateFrontGrid(this.rotate);
            }
            this._virtualMoveDistance = distance;
            this._virtualMoveRotate = this.rotate;
        }

        _virtualMoveReset() {
            if (this._virtualMoveDistance && this._virtualMoveRotate) {
                for (let i = 0; i < this._virtualMoveDistance; i++) {
                    this._locateFrontGrid(this._setSpecialRotate(this._virtualMoveRotate - 180));
                }
            }
            this._virtualMoveDistance = null;
            this._virtualMoveRotate = null;
        }

        getCrushStatus() {
            return new Promise((resolve) => {
                this._checkCrush(
                    G_Define.CRUSH_OBJECT,
                    (boolCrush, CRUSH_PATH, CRUSH_OBJECT, CRUSH_VIRTUAL) => {
                        resolve({
                            CRUSH_STATUS: boolCrush || !CRUSH_PATH[0] || CRUSH_OBJECT[0] || CRUSH_VIRTUAL[0],
                            CRUSH_OBJECT: CRUSH_OBJECT ? CRUSH_OBJECT[1] : null,
                            CRUSH_PATH: CRUSH_PATH ? CRUSH_PATH[1] : null
                        });
                    }
                );
            });
        }

        _setSpecialRotate(rot) {
            if (rot > 360) rot -= 360;
            if (rot <= 0) rot += 360;
            return rot;
        }

        _getSelectMotion(act, rot = this.rotate) {
            let str;
            switch (rot) {
                case 90:
                case 270: {
                    str = `${act}Right`;
                    break;
                }
                case 180: {
                    str = `${act}Bottom`;
                    break;
                }
                case 360: {
                    str = `${act}Top`;
                    break;
                }
                default:
            }

            return str;
        }

        _setArea() {
            const frames = this._sprite._frames.slice();
            const { width } = frames.sort((a, b) => {
                return b.rect.width - a.rect.width;
            }).shift().rect;

            // const bounds = this._object.getBounds();

            this._container.scale = this._w / width;
            this.rotate = this.rotate;
        }

        __setPoint() {
            const bounds = this._object.getBounds();
            this._container.regX = bounds.width * this._pointX / 100;
            this._container.regY = bounds.height * this._pointY / 100;
        }

        _setPoint(px, py) {
            if (super._checkReg(px, py)) {
                this._container.regX = this._pointX > 50
                    ? (this._pointX - 50) * -1
                    : Math.abs(this._pointX - 50);
                this._container.regY = this._pointY > 50
                    ? Math.abs(this._pointY - 50)
                    : this._pointY - 50;

                this.regX = this._container.regX;
                this.regY = this._container.regY;
                this.rotate = this._rotate;
            }
        }

        get _checkMoveStatus() {
            if (this._moveStatus) return true;
            this._moveStatus = true;
            return false;
        }

        get animation() { return this._animation; }

        set animation(animation) {
            this._animation = animation;
            this._object.gotoAndPlay(animation);
        }

        get _speed() { return this.CODMOS.ANIMATE._tween.getCanvas().speed; }

        set _speed(speed) {
            this.CODMOS.ANIMATE._tween.getCanvas()._speed = speed;
            this._sprite.animations
                .forEach((e) => {
                    this._sprite.getAnimation(e).speed = e.startsWith('Dancing')
                        ? 1
                        : speed * (1000 / 24 * this._sprite.getAnimation(e).frames.length) / 888;
                });
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/graphic/G_SpriteHero.js